import * as Yup from 'yup';
import {
  OUTDOOR_GYM_EQUIPMENT_ID,
  OwnershipTypeList,
} from '../../../../utils/enum';

const koreanAndNumberPattern = /^[\uAC00-\uD7A3\d]*$/;

export const facilitySchema = {
  addressName: Yup.string().required('필수 입력값입니다.'),
  addressNote: Yup.string().max(100, '최대 100자입니다.').nullable(),
  categoryId: Yup.string().required('필수 입력값입니다.'),
  subCategoryId: Yup.string().when('categoryId', {
    is: value => value === OUTDOOR_GYM_EQUIPMENT_ID,
    then: schema => schema.required('필수 입력값입니다.'),
    otherwise: schema => schema.nullable(),
  }),
  subCategoryType: Yup.string().when('categoryId', {
    is: value => value === OUTDOOR_GYM_EQUIPMENT_ID,
    then: schema => schema.required('필수 입력값입니다.'),
    otherwise: schema => schema.nullable(),
  }),
  title: Yup.string()
    .max(100, '최대 100자입니다.')
    .required('필수 입력값입니다.'),
  serialNumber: Yup.string()
    .required('필수 입력값입니다.')
    .matches(
      koreanAndNumberPattern,
      '-없이 해당동과 관리번호 숫자를 입력해주세요',
    )
    .test(
      'last-four-are-digits',
      '해당동을 제외한 관리번호는 숫자로만 입력이 가능합니다.',
      value => {
        const lastFourCharacters = value.slice(-4);
        return /^\d{4}$/.test(lastFourCharacters);
      },
    )
    .min(5, '- 제외 최소 5자리 이상으로 입력해주세요.')
    .max(24, '- 제외 최대 24자리 이하로 입력해주세요.'),

  manageDepartment: Yup.string().nullable(),
  usedAs: Yup.string().max(100, '최대 100자입니다.').nullable(),
  installDepartment: Yup.string().nullable(),
  contactNumber: Yup.string()
    .max(20, '연락처는 20자 이하입니다.')
    .matches(/^\d+$/, '연락처는 -없이 숫자만 입력해주세요.')
    .transform(v => (v === '' ? undefined : v))
    .nullable(),
  consignedOrg: Yup.string().nullable(),
  administrativeRegion: Yup.string().max(100, '최대 100자입니다.').nullable(),
  actualRegion: Yup.string().max(100, '최대 100자입니다.').nullable(),
  notes: Yup.string().max(1000, '최대 1000자입니다.').nullable(),
  overviewImage: Yup.mixed().nullable(),
  consignedStartDate: Yup.date().nullable(),
  consignedEndDate: Yup.date().nullable(),
};

export const facilityDefaultValues = {
  addressNote: '',
  categoryType: '',
  categoryId: '',
  title: '',
  serialNumber: '',
  dateOfInstall: new Date(),
  maintenanceDepartment: '',
  subCategoryType: '',
  subCategoryId: '',
  ownershipType: OwnershipTypeList.PUBLIC,
  usedAs: '',
  occupyingSpace: undefined,
  installCostNation: undefined,
  installCostCity: undefined,
  installCostDistrict: undefined,
  installDepartment: '',
  manageDepartment: '',
  contactNumber: '',
  consignedOrg: '',
  consignedStartDate: null,
  consignedEndDate: null,
  administrativeRegion: '',
  actualRegion: '',
  notes: '',
  overviewImage: null,
  facilityImage: null,
  tagImage: null,
  attachments: [],
};
